import { EmptyBase } from '@rimbu/collection-types/set-custom';
export class OrderedSetEmpty extends EmptyBase {
    constructor(context) {
        super();
        this.context = context;
    }
    get order() {
        return this.context.listContext.empty();
    }
    get sourceSet() {
        return this.context.setContext.empty();
    }
    has() {
        return false;
    }
    add(value) {
        return this.context.createNonEmpty(this.context.listContext.of(value), this.context.setContext.of(value));
    }
    addAll(values) {
        return this.context.from(values);
    }
    remove() {
        return this;
    }
    removeAll() {
        return this;
    }
    union(other) {
        if (this.context.isNonEmptyInstance(other) &&
            other.context === this.context) {
            return other;
        }
        return this.context.from(other);
    }
    difference() {
        return this.context.empty();
    }
    intersect() {
        return this.context.empty();
    }
    symDifference(other) {
        return this.union(other);
    }
    toBuilder() {
        return this.context.builder();
    }
    toString() {
        return 'OrderedSet()';
    }
    toJSON() {
        return {
            dataType: this.context.typeTag,
            value: [],
        };
    }
}
//# sourceMappingURL=empty.mjs.map